import { Check } from "lucide-react";

const linkFilled = (links) => Object.values(links || {}).some((v) => (v || "").trim());

const CHECKS = [
  { key: "avatar", label: "Add an avatar", target: "meter-avatar", done: (p) => !!p.avatar },
  { key: "name", label: "Add your name", target: "profile-name-input", done: (p) => !!(p.name || "").trim() },
  { key: "bio", label: "Write a bio", target: "profile-bio-input", done: (p) => (p.bio || "").trim().length >= 20 },
  { key: "location", label: "Add your location", target: "profile-location-input", done: (p) => !!(p.location || "").trim() },
  { key: "roles", label: "Pick your roles", target: "meter-roles", done: (p) => (p.roles || []).length > 0 },
  { key: "genres", label: "Pick your genres", target: "meter-genres", done: (p) => (p.genres || []).length > 0 },
  { key: "song", label: "Upload a song", target: "meter-songs", done: (p) => (p.songs || []).length > 0 },
  { key: "video", label: "Record a 15s intro video", target: "meter-video", done: (p) => !!p.intro_video },
  { key: "gallery", label: "Add a gallery image", target: "meter-gallery", done: (p) => (p.gallery || []).length > 0 },
  { key: "links", label: "Link a social profile", target: "meter-links", done: (p) => linkFilled(p.links) },
];

export function ProfileMeter({ profile, onJump }) {
  const results = CHECKS.map((c) => ({ ...c, complete: c.done(profile) }));
  const doneCount = results.filter((r) => r.complete).length;
  const pct = Math.round((doneCount / results.length) * 100);
  const remaining = results.filter((r) => !r.complete);
  const complete = pct === 100;

  return (
    <div data-testid="profile-meter" className="border border-line bg-surface p-6 md:p-7 mb-10">
      <div className="flex items-baseline justify-between gap-4 mb-4">
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-ash">
          {complete ? "HausCard complete" : "Card completeness"}
        </span>
        <span data-testid="profile-meter-pct" className={`font-heading text-3xl font-bold tracking-tighter ${complete ? "text-gold" : "text-cream"}`}>
          {pct}%
        </span>
      </div>

      <div className="h-2 w-full bg-ink border border-line overflow-hidden">
        <div
          data-testid="profile-meter-bar"
          className="h-full bg-gold transition-[width] duration-700 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>

      {complete ? (
        <p className="text-sm text-ash mt-4 flex items-center gap-2">
          <Check size={15} className="text-gold shrink-0" /> Your card is complete — you show up your best across the Haus.
        </p>
      ) : (
        <div className="mt-5">
          <p className="text-xs text-ash mb-3">Finish these to stand out — tap to jump straight there:</p>
          <div className="flex flex-wrap gap-2">
            {remaining.map((r) => (
              <button
                key={r.key}
                type="button"
                onClick={() => onJump?.(r.target)}
                data-testid={`meter-todo-${r.key}`}
                className="font-mono text-[11px] uppercase tracking-wide text-cream border border-line px-3 py-1.5 hover:border-gold hover:text-gold transition-colors cursor-pointer"
              >
                {r.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
